import { render } from "./createtask.vue?vue&type=template&id=c7af79c4"
import script from "./createtask.vue?vue&type=script&lang=js"
export * from "./createtask.vue?vue&type=script&lang=js"

import "./createtask.vue?vue&type=style&index=0&id=c7af79c4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__